import { searchableItems, User } from 'types/models';
import { ILoadingStateWithData } from 'types/reducerState';

export type ConvertModelToSearchableFn<T = any> = (
  data: ILoadingStateWithData<T>,
) => ILoadingStateWithData<searchableItems>;

export const convertUserToEmailSearchable: ConvertModelToSearchableFn<
  User[]
> = model => {
  const { loading, error, data } = model;
  //TODO:Can extract the shared blocks into shared function when having more
  /**
   * NOTE: Currently the `loading and error` are not used yet.
   * But keep in mind, please also try to return data even loading to prevent flicker in searchable area
   */

  if (error || !data?.length) {
    return {
      data: [],
      error: true,
      loading: false,
    };
  }

  return {
    data: data?.length
      ? data
          .filter(user => user.email)
          .map(user => ({ label: user.email!, value: user.email! }))
      : [],
    loading: loading,
    error: false,
  };
};
